import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { MdLogout } from "react-icons/md";
import { toast } from "react-toastify";
import { sidebarItems } from "../admin-data/data";
import { MdOutlineClose } from "react-icons/md";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../redux/store/sidebarSlice";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/store/userSlice";
const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeParent, setActiveParent] = useState(0);
  const [activeChild, setActiveChild] = useState(null);
  const isOpen = useSelector((state) => state.sidebar.isOpen);
  const handleParentClick = (index) => {
    if (activeParent === index) {
      setActiveParent(null); // collapse if already open
    } else {
      setActiveParent(index);
    }
  };

  const handleChildClick = (childId) => {
    setActiveChild(childId);
  };
  const handleLogout = () => {
    dispatch(logout());
    toast.success("You have logged out successfully!", { autoClose: 3000 });
    navigate("/");
  };
  return (
    <div
      className={`${isOpen ? "flex" : "hidden"} relative flex-col h-screen w-[300px] bg-black  border-r border-gray-700 isMobile`}
    >
      {/* Top Section */}
      <div className="flex justify-between items-center w-full px-[1rem] py-4 border-b border-gray-300">
        <img src={logo} alt="" className="w-[150px]" />
        <button className="close" onClick={() => dispatch(toggleSidebar())}>
          <MdOutlineClose size={"30"} color="white" />{" "}
        </button>
      </div>

      {/* Middle Section */}
      <div className="flex flex-col items-center gap-2 p-4 w-[250px] bg-black h-screen overflow-y-auto">
        {sidebarItems.map((item, index) => (
          <div key={index} className="w-full flex flex-col">
            {/* Parent Item */}
            <div
              onClick={() => {
                // Toggle dropdown if sublinks exist
                if (item.sublinks) {
                  handleParentClick(index);
                }

                // Navigate if parent has a link
                if (item.link) {
                  navigate(item.link);
                }
              }}
              className={`flex justify-between items-center cursor-pointer px-4 py-2 rounded-lg transition-all duration-200
          ${activeParent === index ? "buttons active" : "text-white hover:bg-gray-700"}
        `}
            >
              <div className="flex items-center gap-2">
                {item.icon}
                {item.title}
              </div>

              {/* Show arrow only if sublinks exist */}
              {item.sublinks &&
                (activeParent === index ? (
                  <IoIosArrowDown size="1.2rem" />
                ) : (
                  <IoIosArrowForward size="1.2rem" />
                ))}
            </div>

            {/* Sublinks */}
            {item.sublinks && activeParent === index && (
              <div className="flex flex-col pl-8 mt-1 gap-1">
                {item.sublinks.map((sub, subIndex) => (
                  <button
                    key={subIndex}
                    onClick={() => {
                      handleChildClick(sub.id);
                      if (sub.link) navigate(sub.link); // child navigation
                    }}
                    className={`text-left px-2 py-1 rounded-md w-full transition-all duration-200
                ${activeChild === sub.id ? "buttons active" : "text-white hover:bg-gray-700"}
              `}
                  >
                    {sub.title}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Bottom Section */}
      <div className="flex items-center justify-center p-10">
        <button
          onClick={handleLogout}
          className="flex items-center justify-center gap-1 transition duration-300 ease-in-out p-2 text-white hover:text-yellow-400 text-xl"
        >
          <MdLogout /> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
